import axios, { type AxiosError } from 'axios'
import { useCallback } from 'react'

import { type CoreApiResponseErrorValidation } from '@flecto/types'

import { useNotifications } from '../../../flecto-ui/src'

type ErrorDetail = {
  field: string
  detail: string
}

export const useHandleAxiosError = () => {
  const { showNotification } = useNotifications()

  const handleError = useCallback(
    (error: unknown, customHandlers?: { [key: string]: () => void }) => {
      if (axios.isAxiosError(error)) {
        const errorData = error?.response
          ?.data as CoreApiResponseErrorValidation

        errorData.errors.forEach((e: ErrorDetail) => {
          if (customHandlers && customHandlers[e.field]) {
            customHandlers[e.field]()
          } else {
            showNotification({
              type: 'error',
              message: e.detail,
            })
          }
        })
      }
    },
    []
  )

  const getErrorMessages = useCallback(
    (error: AxiosError, fieldMapping?: { [key: string]: string }) => {
      const errors: { field: string; errorMessage: string }[] = []
      if (error.response?.status === 422) {
        const errorData = error.response.data as CoreApiResponseErrorValidation
        errorData.errors.forEach((e) => {
          const field =
            fieldMapping && fieldMapping[e.field]
              ? fieldMapping[e.field]
              : e.field
          errors.push({
            field,
            errorMessage: e.detail,
          })
        })
      }

      return errors
    },
    []
  )

  return { handleError, getErrorMessages }
}
